import { apiClient } from "../client";

export interface SubscribePayload {
  email: string;
  name?: string;
}

export interface SubscribeResponse {
  status?: boolean;
  message?: string;
}

/** Newsletter opt-in (POST /newsletter/subscribe). */
export const newsletter = {
  subscribe: (payload: SubscribePayload) =>
    apiClient.post<SubscribeResponse>("/newsletter/subscribe", payload),
};
